import { useCallback } from "react";

import type * as Type from "../type";

type Props = {
	serverData: Type.ServerData.ReservationRequestListByMonthCountServerData | undefined;
};
type Result = {
	queryData: Type.QueryData.ReservationRequestList | undefined;
};

export const useReservationListByMonthCountQueryData = () => {
	/**
	 * QueryData へ変換
	 */
	const onConvertQueryData = useCallback(
		({ serverData }: Props): Result => ({
			queryData: serverData
				? {
						hotelName: serverData.reservationRequestListByMonthCount.hotelName,
						hotelPrefecture: serverData.reservationRequestListByMonthCount.hotelPrefecture,
						reservationList: serverData.reservationRequestListByMonthCount.reservations,
					}
				: undefined,
		}),
		[],
	);

	return {
		onConvertQueryData,
	};
};
